export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_FILLED_ORDERS = "SET_FILLED_ORDERS";
export const SET_PENDING_ORDERS = "SET_PENDING_ORDERS";
export const SET_CANCELLED_ORDERS = "SET_CANCELLED_ORDERS";
export const SET_VOLUME_PROFIT = "SET_VOLUME_PROFIT";
export const SET_ALL_BOTS_COUNT = "SET_ALL_BOTS_COUNT";
